import { render, staticRenderFns } from "./RptMchTraTot.vue?vue&type=template&id=bfb652e8"
import script from "./RptMchTraTot.vue?vue&type=script&lang=js"
export * from "./RptMchTraTot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports